// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

// Extrait TOUJOURS une string lisible depuis une erreur axios/Pydantic v2
export const extractError = (err) => {
  try {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || 'Une erreur est survenue';

    // String simple
    if (typeof detail === 'string') return detail;

    // Pydantic v2 : tableau [{type, loc, msg, input, ctx}, ...]
    if (Array.isArray(detail)) {
      return detail
        .map(d => {
          if (typeof d === 'string') return d;
          if (typeof d === 'object' && d !== null) {
            // loc + msg
            const loc = Array.isArray(d.loc) ? d.loc.join('.') : '';
            const msg = d.msg || d.message || JSON.stringify(d);
            return loc ? `${loc}: ${msg}` : msg;
          }
          return String(d);
        })
        .join(' — ');
    }

    // Objet simple
    if (typeof detail === 'object') {
      return detail.msg || detail.message || JSON.stringify(detail);
    }

    return String(detail);
  } catch {
    return 'Une erreur est survenue';
  }
};

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('wib_user');
    const token  = localStorage.getItem('wib_token');
    if (stored && token) {
      try {
        const u = JSON.parse(stored);
        setUser(u);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch {
        localStorage.removeItem('wib_user');
        localStorage.removeItem('wib_token');
      }
    }
    setLoading(false);
  }, []);

  // Backend attend: POST /auth/login  body JSON: { email, password }
  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { access_token, user: u } = res.data;
    localStorage.setItem('wib_token', access_token);
    localStorage.setItem('wib_user', JSON.stringify(u));
    api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('wib_token');
    localStorage.removeItem('wib_user');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}